// Maintenance/Coming-Soon gating has been removed, the public site is always live.
export default function SiteGate({ children }) {
  return children;
}
